module.exports = __webpack_public_path__ + "img/icon_map_199_off_010.d03e902b.png";